import { DatePicker } from 'element-ui'

const YDatePicker = DatePicker
YDatePicker.$depends = [DatePicker]
YDatePicker.$name = 'y-date-picker'
YDatePicker._name = 'DatePicker 日期选择器'

export default YDatePicker
